import Circle from '../components/Circle';

export const CIRCLE_COLORS = {
  overtime: '#F38E22',
  manually: '#007BFF',
  trackedWithTracker: '#55DE52',
};

export const CIRCLE_COLORS_ELEMENT = {
  overtime: <Circle color={CIRCLE_COLORS.overtime} />,
  manually: <Circle color={CIRCLE_COLORS.manually} />,
  trackedWithTracker: <Circle color={CIRCLE_COLORS.trackedWithTracker} />,
};
